// extracted by mini-css-extract-plugin
export default {"pageView":"News_pageView__SpDGP","contentWrapper":"News_contentWrapper__EKYhs"};